import { render, staticRenderFns } from "./taseNotes.vue?vue&type=template&id=717200d4&scoped=true&"
import script from "./taseNotes.vue?vue&type=script&lang=js&"
export * from "./taseNotes.vue?vue&type=script&lang=js&"
import style0 from "./taseNotes.vue?vue&type=style&index=0&id=717200d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717200d4",
  null
  
)

export default component.exports